import { useState } from "react";
import PropTypes from "prop-types";

import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

/**
 * Outline button that opens a read-only dialog. The content is either plain
 * text, which keeps its line breaks, or a node the caller renders, such as an
 * email frame or a parsed form response.
 */
const TextContentDialog = ({
  label,
  title,
  children,
  disabled = false,
  wide = false,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        disabled={disabled}
        onClick={() => setOpen(true)}
      >
        {label}
      </Button>
      <Dialog open={open} onOpenChange={setOpen} disablePointerDismissal>
        <DialogContent className={wide ? "tw:sm:max-w-5xl" : "tw:sm:max-w-2xl"}>
          <DialogTitle>{title}</DialogTitle>
          <div className="tw:max-h-[70vh] tw:overflow-y-auto tw:break-words tw:whitespace-pre-wrap">
            {children}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

TextContentDialog.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  wide: PropTypes.bool,
};

export default TextContentDialog;
